export default function numberToWord(number: number) {
  const ones = [
    "",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
  ];
  const tens = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];

  const numString = number.toString();

  if (number < 0) throw new Error("Negative numbers are not supported.");

  if (number === 0) return "zero";

  // 1 - 20
  if (number < 20) {
    return ones[number];
  }

  return `${tens[parseInt(numString[0])]} ${ones[parseInt(numString[1])]}`;
}
